// extracted by mini-css-extract-plugin
export var footer = "_pu-0";
export var inherit = "_pu-1";
export var input = "_pu-2";
export var modalContent = "_pu-3";
export var quillEditor = "_pu-4";
export var subtitle = "_pu-5";